import styled from 'styled-components';

const Body = styled.div`
  background-color: ${({ bodycolor }) => bodycolor || '#dededede'};
  width: fit-content;
  min-width: 60px;
  height: 24px;
  border: none;
  color: black;
  padding: 3px 12px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 0px;
  cursor: pointer;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Text = styled.span`
  font-size: 12px;
  letter-spacing: 0;
  text-align: center;
  color: ${({ textcolor }) => textcolor || '#000'};
  font-weight: 600;
`;

const StyledStatusIndicator = {
  Body,
  Text,
};

export default StyledStatusIndicator;
